// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2soxG","inner":"Footer_inner__1SyXR"};